// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ILogoInfoDto } from './ILogoInfoDto';
import {
    ILogoInfoDtoFromJSON,
    ILogoInfoDtoFromJSONTyped,
    ILogoInfoDtoToJSON,
    ILogoInfoDtoToJSONTyped,
} from './ILogoInfoDto';
import type { ICardProcessorInfoDto } from './ICardProcessorInfoDto';
import {
    ICardProcessorInfoDtoFromJSON,
    ICardProcessorInfoDtoFromJSONTyped,
    ICardProcessorInfoDtoToJSON,
    ICardProcessorInfoDtoToJSONTyped,
} from './ICardProcessorInfoDto';
import type { ICheckFundingModelInfoDto } from './ICheckFundingModelInfoDto';
import {
    ICheckFundingModelInfoDtoFromJSON,
    ICheckFundingModelInfoDtoFromJSONTyped,
    ICheckFundingModelInfoDtoToJSON,
    ICheckFundingModelInfoDtoToJSONTyped,
} from './ICheckFundingModelInfoDto';
import type { ICommunicationChannelsInfoDto } from './ICommunicationChannelsInfoDto';
import {
    ICommunicationChannelsInfoDtoFromJSON,
    ICommunicationChannelsInfoDtoFromJSONTyped,
    ICommunicationChannelsInfoDtoToJSON,
    ICommunicationChannelsInfoDtoToJSONTyped,
} from './ICommunicationChannelsInfoDto';
import type { ICommunicationCategoriesInfoDto } from './ICommunicationCategoriesInfoDto';
import {
    ICommunicationCategoriesInfoDtoFromJSON,
    ICommunicationCategoriesInfoDtoFromJSONTyped,
    ICommunicationCategoriesInfoDtoToJSON,
    ICommunicationCategoriesInfoDtoToJSONTyped,
} from './ICommunicationCategoriesInfoDto';
import type { IHsaCustodianInfoDto } from './IHsaCustodianInfoDto';
import {
    IHsaCustodianInfoDtoFromJSON,
    IHsaCustodianInfoDtoFromJSONTyped,
    IHsaCustodianInfoDtoToJSON,
    IHsaCustodianInfoDtoToJSONTyped,
} from './IHsaCustodianInfoDto';
import type { ICardOfferedInfoDto } from './ICardOfferedInfoDto';
import {
    ICardOfferedInfoDtoFromJSON,
    ICardOfferedInfoDtoFromJSONTyped,
    ICardOfferedInfoDtoToJSON,
    ICardOfferedInfoDtoToJSONTyped,
} from './ICardOfferedInfoDto';
import type { IPrinSetupInfoDto } from './IPrinSetupInfoDto';
import {
    IPrinSetupInfoDtoFromJSON,
    IPrinSetupInfoDtoFromJSONTyped,
    IPrinSetupInfoDtoToJSON,
    IPrinSetupInfoDtoToJSONTyped,
} from './IPrinSetupInfoDto';
import type { IElectronicFundingModeInfoDto } from './IElectronicFundingModeInfoDto';
import {
    IElectronicFundingModeInfoDtoFromJSON,
    IElectronicFundingModeInfoDtoFromJSONTyped,
    IElectronicFundingModeInfoDtoToJSON,
    IElectronicFundingModeInfoDtoToJSONTyped,
} from './IElectronicFundingModeInfoDto';
import type { IBinSetupInfoDto } from './IBinSetupInfoDto';
import {
    IBinSetupInfoDtoFromJSON,
    IBinSetupInfoDtoFromJSONTyped,
    IBinSetupInfoDtoToJSON,
    IBinSetupInfoDtoToJSONTyped,
} from './IBinSetupInfoDto';
import type { ICardProductionDateInfoDto } from './ICardProductionDateInfoDto';
import {
    ICardProductionDateInfoDtoFromJSON,
    ICardProductionDateInfoDtoFromJSONTyped,
    ICardProductionDateInfoDtoToJSON,
    ICardProductionDateInfoDtoToJSONTyped,
} from './ICardProductionDateInfoDto';
import type { IAllowDependentCardInfoDto } from './IAllowDependentCardInfoDto';
import {
    IAllowDependentCardInfoDtoFromJSON,
    IAllowDependentCardInfoDtoFromJSONTyped,
    IAllowDependentCardInfoDtoToJSON,
    IAllowDependentCardInfoDtoToJSONTyped,
} from './IAllowDependentCardInfoDto';

/**
 * 
 * @export
 * @interface IOverridablePropertiesValidateDto
 */
export interface IOverridablePropertiesValidateDto {
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    id_source_message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesValidateDto
     */
    account_lockout_time?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    customer_number_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    sso_only_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    tax_id_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    external_administrator_fees_account_method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    external_payroll_contributions_account_method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    external_replenishment_account_method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    root_external_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    outgoing_clearing_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_settlement_clearing_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    interest_clearing_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    elevate_interest_source_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    fee_card_interchange_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    payroll_contributions_hold_period?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    ee_contributions_hold_period?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_phone_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_employer_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    url_state_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    account_manager_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    implementation_manager_message?: string | null;
    /**
     * 
     * @type {ILogoInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    logo_manager_message?: ILogoInfoDto;
    /**
     * 
     * @type {IElectronicFundingModeInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    electronic_funding_mode_manager_message?: IElectronicFundingModeInfoDto;
    /**
     * 
     * @type {ICheckFundingModelInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    check_funding_model_manager_message?: ICheckFundingModelInfoDto;
    /**
     * 
     * @type {ICardOfferedInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_offered_manager_message?: ICardOfferedInfoDto;
    /**
     * 
     * @type {IAllowDependentCardInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    allow_dependent_card_manager_message?: IAllowDependentCardInfoDto;
    /**
     * 
     * @type {ICardProductionDateInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_production_date_manager_message?: ICardProductionDateInfoDto;
    /**
     * 
     * @type {IBinSetupInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    bin_setup_manager_message?: IBinSetupInfoDto;
    /**
     * 
     * @type {IPrinSetupInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    print_setup_manager_message?: IPrinSetupInfoDto;
    /**
     * 
     * @type {ICommunicationChannelsInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    communication_channels_message?: ICommunicationChannelsInfoDto;
    /**
     * 
     * @type {ICommunicationCategoriesInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    communication_categories_message?: ICommunicationCategoriesInfoDto;
    /**
     * 
     * @type {IHsaCustodianInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    hsa_custodian_manager_message?: IHsaCustodianInfoDto;
    /**
     * 
     * @type {ICardProcessorInfoDto}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_processor_manager_message?: ICardProcessorInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    replenishment_frequency_type_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    replenishment_day_number_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_reimbursement_allowed_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_bill_pay_allowed_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    session_timeout_warn_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    session_timeout_logout_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    replenishment_percent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    replenishment_min_value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    replenishment_creep_percent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    replenishment_creep_min?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_file_manager_access_enabled_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_file_auto_post_enabled_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    large_logo_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    minimized_logo_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    dark_large_logo_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    dark_minimized_logo_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    favicon_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    minimum_payment_reimbursement_amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    waiting_for_funds_continue_payment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    ai_adjudication?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    ai_confidence_level?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    email_domain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    email_logo_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    email_logo_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    privacy_policy_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    terms_and_conditions_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    about_us_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    email_theme?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    statement_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    statement_frequency_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    email_illustration_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesValidateDto
     */
    number_of_days_before_plan_start?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof IOverridablePropertiesValidateDto
     */
    prefund_initial_delay_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IOverridablePropertiesValidateDto
     */
    card_processing_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    reservation_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    admin_portal_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    participant_portal_link?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_external_link?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    external_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    pricing_consent?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_organization_orphan?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesValidateDto
     */
    orphan_organization_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesValidateDto
     */
    orphan_start_timing_days?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesValidateDto
     */
    waiting_for_funds_expiration?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    file_location?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    allow_manual_contribution?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    allow_scheduled_contribution?: IOverridablePropertiesValidateDtoAllowScheduledContributionEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_custom_reporting_field_5_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_custom_reporting_field_4_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_custom_reporting_field_3_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_custom_reporting_field_2_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_custom_reporting_field_1_enabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    custom_reporting_field_5_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    custom_reporting_field_4_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    custom_reporting_field_3_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    custom_reporting_field_2_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    custom_reporting_field_1_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    allow_employees_to_edit_address?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    is_claim_offsets_allowed?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    claim_offset_logic?: IOverridablePropertiesValidateDtoClaimOffsetLogicEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    allow_prefund?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesValidateDto
     */
    contribution_push_give_up_days?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    require_participant_mfa?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    require_admin_mfa?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    paper_statement_fees_paid_by?: IOverridablePropertiesValidateDtoPaperStatementFeesPaidByEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    paper_statement_fees_amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    admin_chatbot_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    participant_chatbot_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    allow_renewals?: IOverridablePropertiesValidateDtoAllowRenewalsEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    working_hours?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    substantiation_rate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    admin_sso_only?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    push_provisioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesValidateDto
     */
    automated_org_lock_enabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    external_balance_adjustment_account_method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    balance_adjustment_hold_period?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesValidateDto
     */
    balance_adjustment_push_give_up_days?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesValidateDtoAllowScheduledContributionEnum {
    ALLOWED_WITH_AUTO_APPROVAL = 'ALLOWED_WITH_AUTO_APPROVAL',
    ALLOWED_WITH_MANUAL_APPROVAL = 'ALLOWED_WITH_MANUAL_APPROVAL',
    DISABLED = 'DISABLED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesValidateDtoClaimOffsetLogicEnum {
    PAY_FROM_ANY_ACCOUNT = 'PAY_FROM_ANY_ACCOUNT',
    PAY_FROM_SAME_ACCOUNT = 'PAY_FROM_SAME_ACCOUNT'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesValidateDtoPaperStatementFeesPaidByEnum {
    PARTICIPANT = 'PARTICIPANT',
    ADMIN = 'ADMIN'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesValidateDtoAllowRenewalsEnum {
    NO_RENEWALS = 'NO_RENEWALS',
    BY_REQUEST = 'BY_REQUEST'
}


/**
 * Check if a given object implements the IOverridablePropertiesValidateDto interface.
 */
export function instanceOfIOverridablePropertiesValidateDto(value: object): value is IOverridablePropertiesValidateDto {
    return true;
}

export function IOverridablePropertiesValidateDtoFromJSON(json: any): IOverridablePropertiesValidateDto {
    return IOverridablePropertiesValidateDtoFromJSONTyped(json, false);
}

export function IOverridablePropertiesValidateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOverridablePropertiesValidateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id_source_message': json['id_source_message'] == null ? undefined : json['id_source_message'],
        'account_lockout_time': json['account_lockout_time'] == null ? undefined : json['account_lockout_time'],
        'customer_number_message': json['customer_number_message'] == null ? undefined : json['customer_number_message'],
        'sso_only_message': json['sso_only_message'] == null ? undefined : json['sso_only_message'],
        'tax_id_message': json['tax_id_message'] == null ? undefined : json['tax_id_message'],
        'external_administrator_fees_account_method': json['external_administrator_fees_account_method'] == null ? undefined : json['external_administrator_fees_account_method'],
        'external_payroll_contributions_account_method': json['external_payroll_contributions_account_method'] == null ? undefined : json['external_payroll_contributions_account_method'],
        'external_replenishment_account_method': json['external_replenishment_account_method'] == null ? undefined : json['external_replenishment_account_method'],
        'root_external_account': json['root_external_account'] == null ? undefined : json['root_external_account'],
        'outgoing_clearing_account': json['outgoing_clearing_account'] == null ? undefined : json['outgoing_clearing_account'],
        'card_settlement_clearing_account': json['card_settlement_clearing_account'] == null ? undefined : json['card_settlement_clearing_account'],
        'interest_clearing_account': json['interest_clearing_account'] == null ? undefined : json['interest_clearing_account'],
        'elevate_interest_source_account': json['elevate_interest_source_account'] == null ? undefined : json['elevate_interest_source_account'],
        'fee_card_interchange_account': json['fee_card_interchange_account'] == null ? undefined : json['fee_card_interchange_account'],
        'payroll_contributions_hold_period': json['payroll_contributions_hold_period'] == null ? undefined : json['payroll_contributions_hold_period'],
        'ee_contributions_hold_period': json['ee_contributions_hold_period'] == null ? undefined : json['ee_contributions_hold_period'],
        'card_phone_number': json['card_phone_number'] == null ? undefined : json['card_phone_number'],
        'card_url': json['card_url'] == null ? undefined : json['card_url'],
        'card_employer_name': json['card_employer_name'] == null ? undefined : json['card_employer_name'],
        'url_state_message': json['url_state_message'] == null ? undefined : json['url_state_message'],
        'account_manager_message': json['account_manager_message'] == null ? undefined : json['account_manager_message'],
        'implementation_manager_message': json['implementation_manager_message'] == null ? undefined : json['implementation_manager_message'],
        'logo_manager_message': json['logo_manager_message'] == null ? undefined : ILogoInfoDtoFromJSON(json['logo_manager_message']),
        'electronic_funding_mode_manager_message': json['electronic_funding_mode_manager_message'] == null ? undefined : IElectronicFundingModeInfoDtoFromJSON(json['electronic_funding_mode_manager_message']),
        'check_funding_model_manager_message': json['check_funding_model_manager_message'] == null ? undefined : ICheckFundingModelInfoDtoFromJSON(json['check_funding_model_manager_message']),
        'card_offered_manager_message': json['card_offered_manager_message'] == null ? undefined : ICardOfferedInfoDtoFromJSON(json['card_offered_manager_message']),
        'allow_dependent_card_manager_message': json['allow_dependent_card_manager_message'] == null ? undefined : IAllowDependentCardInfoDtoFromJSON(json['allow_dependent_card_manager_message']),
        'card_production_date_manager_message': json['card_production_date_manager_message'] == null ? undefined : ICardProductionDateInfoDtoFromJSON(json['card_production_date_manager_message']),
        'bin_setup_manager_message': json['bin_setup_manager_message'] == null ? undefined : IBinSetupInfoDtoFromJSON(json['bin_setup_manager_message']),
        'print_setup_manager_message': json['print_setup_manager_message'] == null ? undefined : IPrinSetupInfoDtoFromJSON(json['print_setup_manager_message']),
        'communication_channels_message': json['communication_channels_message'] == null ? undefined : ICommunicationChannelsInfoDtoFromJSON(json['communication_channels_message']),
        'communication_categories_message': json['communication_categories_message'] == null ? undefined : ICommunicationCategoriesInfoDtoFromJSON(json['communication_categories_message']),
        'hsa_custodian_manager_message': json['hsa_custodian_manager_message'] == null ? undefined : IHsaCustodianInfoDtoFromJSON(json['hsa_custodian_manager_message']),
        'card_processor_manager_message': json['card_processor_manager_message'] == null ? undefined : ICardProcessorInfoDtoFromJSON(json['card_processor_manager_message']),
        'replenishment_frequency_type_message': json['replenishment_frequency_type_message'] == null ? undefined : json['replenishment_frequency_type_message'],
        'replenishment_day_number_message': json['replenishment_day_number_message'] == null ? undefined : json['replenishment_day_number_message'],
        'is_reimbursement_allowed_message': json['is_reimbursement_allowed_message'] == null ? undefined : json['is_reimbursement_allowed_message'],
        'is_bill_pay_allowed_message': json['is_bill_pay_allowed_message'] == null ? undefined : json['is_bill_pay_allowed_message'],
        'session_timeout_warn_message': json['session_timeout_warn_message'] == null ? undefined : json['session_timeout_warn_message'],
        'session_timeout_logout_message': json['session_timeout_logout_message'] == null ? undefined : json['session_timeout_logout_message'],
        'replenishment_percent': json['replenishment_percent'] == null ? undefined : json['replenishment_percent'],
        'replenishment_min_value': json['replenishment_min_value'] == null ? undefined : json['replenishment_min_value'],
        'replenishment_creep_percent': json['replenishment_creep_percent'] == null ? undefined : json['replenishment_creep_percent'],
        'replenishment_creep_min': json['replenishment_creep_min'] == null ? undefined : json['replenishment_creep_min'],
        'is_file_manager_access_enabled_message': json['is_file_manager_access_enabled_message'] == null ? undefined : json['is_file_manager_access_enabled_message'],
        'is_file_auto_post_enabled_message': json['is_file_auto_post_enabled_message'] == null ? undefined : json['is_file_auto_post_enabled_message'],
        'large_logo_path': json['large_logo_path'] == null ? undefined : json['large_logo_path'],
        'minimized_logo_path': json['minimized_logo_path'] == null ? undefined : json['minimized_logo_path'],
        'dark_large_logo_path': json['dark_large_logo_path'] == null ? undefined : json['dark_large_logo_path'],
        'dark_minimized_logo_path': json['dark_minimized_logo_path'] == null ? undefined : json['dark_minimized_logo_path'],
        'favicon_path': json['favicon_path'] == null ? undefined : json['favicon_path'],
        'minimum_payment_reimbursement_amount': json['minimum_payment_reimbursement_amount'] == null ? undefined : json['minimum_payment_reimbursement_amount'],
        'waiting_for_funds_continue_payment': json['waiting_for_funds_continue_payment'] == null ? undefined : json['waiting_for_funds_continue_payment'],
        'ai_adjudication': json['ai_adjudication'] == null ? undefined : json['ai_adjudication'],
        'ai_confidence_level': json['ai_confidence_level'] == null ? undefined : json['ai_confidence_level'],
        'email_domain': json['email_domain'] == null ? undefined : json['email_domain'],
        'email_logo_type': json['email_logo_type'] == null ? undefined : json['email_logo_type'],
        'email_logo_path': json['email_logo_path'] == null ? undefined : json['email_logo_path'],
        'privacy_policy_link': json['privacy_policy_link'] == null ? undefined : json['privacy_policy_link'],
        'terms_and_conditions_link': json['terms_and_conditions_link'] == null ? undefined : json['terms_and_conditions_link'],
        'about_us_link': json['about_us_link'] == null ? undefined : json['about_us_link'],
        'email_theme': json['email_theme'] == null ? undefined : json['email_theme'],
        'statement_type': json['statement_type'] == null ? undefined : json['statement_type'],
        'statement_frequency_type': json['statement_frequency_type'] == null ? undefined : json['statement_frequency_type'],
        'email_illustration_id': json['email_illustration_id'] == null ? undefined : json['email_illustration_id'],
        'number_of_days_before_plan_start': json['number_of_days_before_plan_start'] == null ? undefined : json['number_of_days_before_plan_start'],
        'prefund_initial_delay_date': json['prefund_initial_delay_date'] == null ? undefined : (new Date(json['prefund_initial_delay_date'])),
        'card_processing_start_date': json['card_processing_start_date'] == null ? undefined : (new Date(json['card_processing_start_date'])),
        'reservation_code': json['reservation_code'] == null ? undefined : json['reservation_code'],
        'admin_portal_link': json['admin_portal_link'] == null ? undefined : json['admin_portal_link'],
        'participant_portal_link': json['participant_portal_link'] == null ? undefined : json['participant_portal_link'],
        'is_external_link': json['is_external_link'] == null ? undefined : json['is_external_link'],
        'external_link': json['external_link'] == null ? undefined : json['external_link'],
        'pricing_consent': json['pricing_consent'] == null ? undefined : json['pricing_consent'],
        'is_organization_orphan': json['is_organization_orphan'] == null ? undefined : json['is_organization_orphan'],
        'orphan_organization_id': json['orphan_organization_id'] == null ? undefined : json['orphan_organization_id'],
        'orphan_start_timing_days': json['orphan_start_timing_days'] == null ? undefined : json['orphan_start_timing_days'],
        'waiting_for_funds_expiration': json['waiting_for_funds_expiration'] == null ? undefined : json['waiting_for_funds_expiration'],
        'file_location': json['file_location'] == null ? undefined : json['file_location'],
        'allow_manual_contribution': json['allowManualContribution'] == null ? undefined : json['allowManualContribution'],
        'allow_scheduled_contribution': json['allowScheduledContribution'] == null ? undefined : json['allowScheduledContribution'],
        'is_custom_reporting_field_5_enabled': json['is_custom_reporting_field_5_enabled'] == null ? undefined : json['is_custom_reporting_field_5_enabled'],
        'is_custom_reporting_field_4_enabled': json['is_custom_reporting_field_4_enabled'] == null ? undefined : json['is_custom_reporting_field_4_enabled'],
        'is_custom_reporting_field_3_enabled': json['is_custom_reporting_field_3_enabled'] == null ? undefined : json['is_custom_reporting_field_3_enabled'],
        'is_custom_reporting_field_2_enabled': json['is_custom_reporting_field_2_enabled'] == null ? undefined : json['is_custom_reporting_field_2_enabled'],
        'is_custom_reporting_field_1_enabled': json['is_custom_reporting_field_1_enabled'] == null ? undefined : json['is_custom_reporting_field_1_enabled'],
        'custom_reporting_field_5_name': json['custom_reporting_field_5_name'] == null ? undefined : json['custom_reporting_field_5_name'],
        'custom_reporting_field_4_name': json['custom_reporting_field_4_name'] == null ? undefined : json['custom_reporting_field_4_name'],
        'custom_reporting_field_3_name': json['custom_reporting_field_3_name'] == null ? undefined : json['custom_reporting_field_3_name'],
        'custom_reporting_field_2_name': json['custom_reporting_field_2_name'] == null ? undefined : json['custom_reporting_field_2_name'],
        'custom_reporting_field_1_name': json['custom_reporting_field_1_name'] == null ? undefined : json['custom_reporting_field_1_name'],
        'allow_employees_to_edit_address': json['allow_employees_to_edit_address'] == null ? undefined : json['allow_employees_to_edit_address'],
        'is_claim_offsets_allowed': json['is_claim_offsets_allowed'] == null ? undefined : json['is_claim_offsets_allowed'],
        'claim_offset_logic': json['claim_offset_logic'] == null ? undefined : json['claim_offset_logic'],
        'allow_prefund': json['allow_prefund'] == null ? undefined : json['allow_prefund'],
        'contribution_push_give_up_days': json['contribution_push_give_up_days'] == null ? undefined : json['contribution_push_give_up_days'],
        'require_participant_mfa': json['require_participant_mfa'] == null ? undefined : json['require_participant_mfa'],
        'require_admin_mfa': json['require_admin_mfa'] == null ? undefined : json['require_admin_mfa'],
        'paper_statement_fees_paid_by': json['paper_statement_fees_paid_by'] == null ? undefined : json['paper_statement_fees_paid_by'],
        'paper_statement_fees_amount': json['paper_statement_fees_amount'] == null ? undefined : json['paper_statement_fees_amount'],
        'admin_chatbot_link': json['admin_chatbot_link'] == null ? undefined : json['admin_chatbot_link'],
        'participant_chatbot_link': json['participant_chatbot_link'] == null ? undefined : json['participant_chatbot_link'],
        'allow_renewals': json['allow_renewals'] == null ? undefined : json['allow_renewals'],
        'working_hours': json['working_hours'] == null ? undefined : json['working_hours'],
        'substantiation_rate': json['substantiation_rate'] == null ? undefined : json['substantiation_rate'],
        'admin_sso_only': json['admin_sso_only'] == null ? undefined : json['admin_sso_only'],
        'push_provisioning': json['push_provisioning'] == null ? undefined : json['push_provisioning'],
        'automated_org_lock_enabled': json['automated_org_lock_enabled'] == null ? undefined : json['automated_org_lock_enabled'],
        'external_balance_adjustment_account_method': json['external_balance_adjustment_account_method'] == null ? undefined : json['external_balance_adjustment_account_method'],
        'balance_adjustment_hold_period': json['balance_adjustment_hold_period'] == null ? undefined : json['balance_adjustment_hold_period'],
        'balance_adjustment_push_give_up_days': json['balance_adjustment_push_give_up_days'] == null ? undefined : json['balance_adjustment_push_give_up_days'],
    };
}

export function IOverridablePropertiesValidateDtoToJSON(json: any): IOverridablePropertiesValidateDto {
    return IOverridablePropertiesValidateDtoToJSONTyped(json, false);
}

export function IOverridablePropertiesValidateDtoToJSONTyped(value?: IOverridablePropertiesValidateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id_source_message': value['id_source_message'],
        'account_lockout_time': value['account_lockout_time'],
        'customer_number_message': value['customer_number_message'],
        'sso_only_message': value['sso_only_message'],
        'tax_id_message': value['tax_id_message'],
        'external_administrator_fees_account_method': value['external_administrator_fees_account_method'],
        'external_payroll_contributions_account_method': value['external_payroll_contributions_account_method'],
        'external_replenishment_account_method': value['external_replenishment_account_method'],
        'root_external_account': value['root_external_account'],
        'outgoing_clearing_account': value['outgoing_clearing_account'],
        'card_settlement_clearing_account': value['card_settlement_clearing_account'],
        'interest_clearing_account': value['interest_clearing_account'],
        'elevate_interest_source_account': value['elevate_interest_source_account'],
        'fee_card_interchange_account': value['fee_card_interchange_account'],
        'payroll_contributions_hold_period': value['payroll_contributions_hold_period'],
        'ee_contributions_hold_period': value['ee_contributions_hold_period'],
        'card_phone_number': value['card_phone_number'],
        'card_url': value['card_url'],
        'card_employer_name': value['card_employer_name'],
        'url_state_message': value['url_state_message'],
        'account_manager_message': value['account_manager_message'],
        'implementation_manager_message': value['implementation_manager_message'],
        'logo_manager_message': ILogoInfoDtoToJSON(value['logo_manager_message']),
        'electronic_funding_mode_manager_message': IElectronicFundingModeInfoDtoToJSON(value['electronic_funding_mode_manager_message']),
        'check_funding_model_manager_message': ICheckFundingModelInfoDtoToJSON(value['check_funding_model_manager_message']),
        'card_offered_manager_message': ICardOfferedInfoDtoToJSON(value['card_offered_manager_message']),
        'allow_dependent_card_manager_message': IAllowDependentCardInfoDtoToJSON(value['allow_dependent_card_manager_message']),
        'card_production_date_manager_message': ICardProductionDateInfoDtoToJSON(value['card_production_date_manager_message']),
        'bin_setup_manager_message': IBinSetupInfoDtoToJSON(value['bin_setup_manager_message']),
        'print_setup_manager_message': IPrinSetupInfoDtoToJSON(value['print_setup_manager_message']),
        'communication_channels_message': ICommunicationChannelsInfoDtoToJSON(value['communication_channels_message']),
        'communication_categories_message': ICommunicationCategoriesInfoDtoToJSON(value['communication_categories_message']),
        'hsa_custodian_manager_message': IHsaCustodianInfoDtoToJSON(value['hsa_custodian_manager_message']),
        'card_processor_manager_message': ICardProcessorInfoDtoToJSON(value['card_processor_manager_message']),
        'replenishment_frequency_type_message': value['replenishment_frequency_type_message'],
        'replenishment_day_number_message': value['replenishment_day_number_message'],
        'is_reimbursement_allowed_message': value['is_reimbursement_allowed_message'],
        'is_bill_pay_allowed_message': value['is_bill_pay_allowed_message'],
        'session_timeout_warn_message': value['session_timeout_warn_message'],
        'session_timeout_logout_message': value['session_timeout_logout_message'],
        'replenishment_percent': value['replenishment_percent'],
        'replenishment_min_value': value['replenishment_min_value'],
        'replenishment_creep_percent': value['replenishment_creep_percent'],
        'replenishment_creep_min': value['replenishment_creep_min'],
        'is_file_manager_access_enabled_message': value['is_file_manager_access_enabled_message'],
        'is_file_auto_post_enabled_message': value['is_file_auto_post_enabled_message'],
        'large_logo_path': value['large_logo_path'],
        'minimized_logo_path': value['minimized_logo_path'],
        'dark_large_logo_path': value['dark_large_logo_path'],
        'dark_minimized_logo_path': value['dark_minimized_logo_path'],
        'favicon_path': value['favicon_path'],
        'minimum_payment_reimbursement_amount': value['minimum_payment_reimbursement_amount'],
        'waiting_for_funds_continue_payment': value['waiting_for_funds_continue_payment'],
        'ai_adjudication': value['ai_adjudication'],
        'ai_confidence_level': value['ai_confidence_level'],
        'email_domain': value['email_domain'],
        'email_logo_type': value['email_logo_type'],
        'email_logo_path': value['email_logo_path'],
        'privacy_policy_link': value['privacy_policy_link'],
        'terms_and_conditions_link': value['terms_and_conditions_link'],
        'about_us_link': value['about_us_link'],
        'email_theme': value['email_theme'],
        'statement_type': value['statement_type'],
        'statement_frequency_type': value['statement_frequency_type'],
        'email_illustration_id': value['email_illustration_id'],
        'number_of_days_before_plan_start': value['number_of_days_before_plan_start'],
        'prefund_initial_delay_date': value['prefund_initial_delay_date'] === null ? null : ((value['prefund_initial_delay_date'] as any)?.toISOString()),
        'card_processing_start_date': value['card_processing_start_date'] === null ? null : ((value['card_processing_start_date'] as any)?.toISOString()),
        'reservation_code': value['reservation_code'],
        'admin_portal_link': value['admin_portal_link'],
        'participant_portal_link': value['participant_portal_link'],
        'is_external_link': value['is_external_link'],
        'external_link': value['external_link'],
        'pricing_consent': value['pricing_consent'],
        'is_organization_orphan': value['is_organization_orphan'],
        'orphan_organization_id': value['orphan_organization_id'],
        'orphan_start_timing_days': value['orphan_start_timing_days'],
        'waiting_for_funds_expiration': value['waiting_for_funds_expiration'],
        'file_location': value['file_location'],
        'allowManualContribution': value['allow_manual_contribution'],
        'allowScheduledContribution': value['allow_scheduled_contribution'],
        'is_custom_reporting_field_5_enabled': value['is_custom_reporting_field_5_enabled'],
        'is_custom_reporting_field_4_enabled': value['is_custom_reporting_field_4_enabled'],
        'is_custom_reporting_field_3_enabled': value['is_custom_reporting_field_3_enabled'],
        'is_custom_reporting_field_2_enabled': value['is_custom_reporting_field_2_enabled'],
        'is_custom_reporting_field_1_enabled': value['is_custom_reporting_field_1_enabled'],
        'custom_reporting_field_5_name': value['custom_reporting_field_5_name'],
        'custom_reporting_field_4_name': value['custom_reporting_field_4_name'],
        'custom_reporting_field_3_name': value['custom_reporting_field_3_name'],
        'custom_reporting_field_2_name': value['custom_reporting_field_2_name'],
        'custom_reporting_field_1_name': value['custom_reporting_field_1_name'],
        'allow_employees_to_edit_address': value['allow_employees_to_edit_address'],
        'is_claim_offsets_allowed': value['is_claim_offsets_allowed'],
        'claim_offset_logic': value['claim_offset_logic'],
        'allow_prefund': value['allow_prefund'],
        'contribution_push_give_up_days': value['contribution_push_give_up_days'],
        'require_participant_mfa': value['require_participant_mfa'],
        'require_admin_mfa': value['require_admin_mfa'],
        'paper_statement_fees_paid_by': value['paper_statement_fees_paid_by'],
        'paper_statement_fees_amount': value['paper_statement_fees_amount'],
        'admin_chatbot_link': value['admin_chatbot_link'],
        'participant_chatbot_link': value['participant_chatbot_link'],
        'allow_renewals': value['allow_renewals'],
        'working_hours': value['working_hours'],
        'substantiation_rate': value['substantiation_rate'],
        'admin_sso_only': value['admin_sso_only'],
        'push_provisioning': value['push_provisioning'],
        'automated_org_lock_enabled': value['automated_org_lock_enabled'],
        'external_balance_adjustment_account_method': value['external_balance_adjustment_account_method'],
        'balance_adjustment_hold_period': value['balance_adjustment_hold_period'],
        'balance_adjustment_push_give_up_days': value['balance_adjustment_push_give_up_days'],
    };
}

